import { useEffect, useState } from 'react';

const KEY = 'atrium.notepad';

/** Personal scratch notepad, stored on this device. */
export function Notepad() {
  const [text, setText] = useState(() => {
    try {
      return localStorage.getItem(KEY) ?? '';
    } catch {
      return '';
    }
  });
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(KEY, text);
      } catch {
        /* ignore */
      }
    }, 300);
    return () => clearTimeout(t);
  }, [text]);
  return (
    <div className="notepad">
      <div className="notepad-head">Notepad</div>
      <textarea autoFocus value={text} onChange={(e) => setText(e.target.value)} placeholder="Jot down anything — notes stay on this device." />
    </div>
  );
}
